import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { getDiscretePurchasePrice } from "../../../lib/auctions/gda/discrete";
import { getProto } from "../../../utils/proto/index";
import AuctionBase from "../AuctionBase";

export const GDADiscreteAuction = ({
  auction,
  now,
  endEpoch,
  customerId,
  shopLoginUrl,
  onPlaceBid,
  currentPrice,
  setCurrentPrice,
  statefulPurchaseQuantity,
  setStatefulPurchaseQuantity,
  setVariant,
}) => {
  const isProto = useMemo(() => getProto(window.location.search), []);

  const [loggedIn, setLoggedIn] = useState(false);

  const [timeLeft, setTimeLeft] = useState(
    endEpoch > now
      ? moment(endEpoch * 1000).unix() - moment(now * 1000).unix()
      : 0
  );

  const [protoQty] = useState(100);
  const [protoSold, setProtoSold] = useState(0);

  useEffect(() => {
    if (timeLeft > 0) {
      let refresh = setTimeout(() => {
        setTimeLeft(Math.floor(timeLeft - 1));
        if (timeLeft % 2 === 0) {
          const price = (() => {
            if (isProto) {
              const soldRng = Math.floor(Math.random() * (10 - 2 + 1) + 2);
              if (protoSold + soldRng > protoQty) {
                setProtoSold(protoQty);
              } else {
                setProtoSold(protoSold + soldRng);
              }
              return getDiscretePurchasePrice(
                100,
                0.001,
                1.01,
                protoSold,
                new Date().getTime() / 1000 - now,
                !statefulPurchaseQuantity ? 1 : Number(statefulPurchaseQuantity)
              );
            } else {
              return getDiscretePurchasePrice(
                auction.starting_price,
                auction.decay_rate,
                auction.scale_factor,
                auction.sold,
                new Date().getTime() / 1000 - auction.start_epoch,
                !statefulPurchaseQuantity ? 1 : Number(statefulPurchaseQuantity)
              );
            }
          })();
          setCurrentPrice(price);
        }
      }, 1000);
      return () => clearTimeout(refresh);
    }
  }, [timeLeft, auction, statefulPurchaseQuantity, setCurrentPrice, protoSold]);

  return (
    <AuctionBase
      auction={auction}
      currentPrice={currentPrice}
      targetDate={endEpoch}
      quantity={isProto ? protoQty : auction.quantity}
      sold={isProto ? protoSold : auction.sold}
      onBidClick={onPlaceBid}
      statefulPurchaseQuantity={statefulPurchaseQuantity}
      setStatefulPurchaseQuantity={setStatefulPurchaseQuantity}
      setVariant={setVariant}
    />
  );
};
